export default __webpack_public_path__ + "static/media/google-classroom.8c37f51f.svg";